import client from "../config/AxiosConfig";

export const GetSurvey = async (id, id_client) => await client.get(`/surveys/${id}/${id_client}`);

export const SubmitSurvey = async (data) => await client.post(`/surveys`, data);